import { render, staticRenderFns } from "./MRLs.vue?vue&type=template&id=5e364424&scoped=true"
import script from "./MRLs.vue?vue&type=script&lang=js"
export * from "./MRLs.vue?vue&type=script&lang=js"
import style0 from "./MRLs.vue?vue&type=style&index=0&id=5e364424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e364424",
  null
  
)

export default component.exports